<template>
      <div class="jumbotron homapt-hide-if-small">
        <div class="row">
          <div class="col">
           <router-link to="/profile/business/dashboard">
             <h4 class="secondary-nav"
                 v-bind:class="{ secondarynavcolored: endPath === 'dashboard' }">Dashboard</h4>
           </router-link>
           <router-link to="/profile/business/details/overview">
             <h4 class="secondary-nav"
                 v-bind:class="{ secondarynavcolored: endPath === 'details' }">Details</h4>
           </router-link>
           <router-link to="/profile/business/contacts">
             <h4 class="secondary-nav"
                 v-bind:class="{ secondarynavcolored: endPath === 'contacts' }">Contacts</h4>
           </router-link>
           <router-link to="/profile/business/advertising">
             <h4 class="secondary-nav"
                 v-bind:class="{ secondarynavcolored: endPath === 'advertising' }">Advertising</h4>
           </router-link>
           <router-link to="/profile/business/security">
             <h4 class="secondary-nav"
                 v-bind:class="{ secondarynavcolored: endPath === 'security' }"
                 v-if="getIdProvider !== 'google'">Security</h4>
           </router-link>
           <router-link to="/">
             <h4 class="secondary-nav"
                 v-on:click="logOut">Log Out</h4>
           </router-link>
          </div>
        </div>
      </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      endPath: null
    }
  },
  created () {
    this.setEndPath()
  },
  computed: {
    ...mapGetters([
      'getIdProvider'
    ])
  },
  watch: {
    '$route' (to, from) {
      this.setEndPath()
    }
  },
  methods: {
    setEndPath () {
      var pathList = (this.$route.path).split('/')
      this.endPath = pathList[3]
    },
    logOut () {
      this.$store.dispatch('logOut')
    }
  }
}
</script>

<style scoped>
@media (max-width: 992px) {
  .homapt-hide-if-small {
    display: none;
  }
}

.jumbotron {
  background-color:  #f1f1f1  !important;
  margin-bottom: 3rem !important;
  border-radius: 25px;
  padding-top: 1rem;
  padding-bottom: 1rem;
}

.secondary-nav {
  border-radius: 15px;
  padding: 10px;
  padding-left: 20px;
}

.secondary-nav:hover {
  background-color: #feedaa;
}

.secondarynavcolored {
  background-color: #feedaa;
}
</style>



// WEBPACK FOOTER //
// src/components/profile/businessProfile/BusinessSubnav.vue